module.exports = __webpack_public_path__ + "img/guolvqi.8985e5b7.jpg";